"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Collapse = function Collapse() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M23.707 10.707l-6.854-6.84a.667.667 0 00-.946 0l-.947.946a.654.654 0 000 .934l4.6 4.586H6a.667.667 0 00-.667.667v1.333A.667.667 0 006 13h13.56l-4.6 4.587a.665.665 0 000 .946l.947.934a.667.667 0 00.946 0l6.854-6.84A1 1 0 0024 11.92v-.507a1.027 1.027 0 00-.293-.706z"
  }), react_1.default.createElement("rect", {
    width: "2.667",
    height: "21.333",
    y: "1",
    fill: "currentColor",
    rx: "0.5"
  }));
};

exports.Collapse = Collapse;